import * as React from 'react';
import { toast } from 'react-toastify';
import { connect, DispatchProp } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router';
import PerfectScrollbar from 'react-perfect-scrollbar';
// import * as PropTypes from 'prop-types'; 
import * as PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { IHistory } from '../../../interfaces';
import { QuestionModel } from '../../../model/QuestionModel';
import { dispatch, marshallAnswersPlantPreventive, getPageTitle } from '../../../utils/generalUtils';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Loader } from '../../reusableComponents/Loader';
import { RenderQuestion } from '../../reusableComponents/FormComponents/RenderQuestion';
import { AllMonthlyPPM1 } from '../../../constants/generals';
import { format } from 'date-fns';
import { submitDailyForm, getDailyPlantPreventiveQuestions } from '../../../services/dailyFormService'; 
import { DailyFormsModel, IDailyFormsModelProps } from '../../../model/DailyFormModel';

export interface IDailyPMFormProps extends DispatchProp<any> {
    questions: QuestionModel[];
    type: string;
    date: string;
    plantId: string;
    userUID: string;
    formId: string;
    history: IHistory;
    form;
    formInstance: DailyFormsModel;
}

export interface IDailyPMFormState {
   
    MonthlyPPM1: {
        Question_Num?: number,
        Question: string
        , Questiontype? : string,
        containsComment?: boolean,
        CommentQuestion?: string,
        CommentQuestionNum?: number,
        CommentQuestionLabel?: string,
        customLabelForComments?: string;
        customLabel?: string;
    }[];

    MonthlyPPM2: {
        Question_Num?: number,
        Question: string
        , Questiontype? : string,
        containsComment?: boolean,
        CommentQuestion?: string,
        CommentQuestionNum?: number,
        CommentQuestionLabel?: string,
        customLabelForComments?: string;
        customLabel?: string;
    }[];
}

export class DailyPMFormImpl extends React.Component<IDailyPMFormProps, IDailyPMFormState> {
    constructor(props: IDailyPMFormProps) {
        super(props);
        this.state = {
            MonthlyPPM1: AllMonthlyPPM1.slice(0, 38),
            MonthlyPPM2:  AllMonthlyPPM1.slice(38),
        };
    }
    refs: {
        images: ImageUpload;
    };

    get value() {
        return this.refs.images.value;
    }
    getChildContext() {
        return { formModel: 'forms.dailyPMForm' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };
    promise = async () => {
        await getDailyPlantPreventiveQuestions(this.props.type, this.props.formId);
    }

    loadDefaultValues = () => {
        if (this.props.formId) {
        this.props.questions.forEach(instance => {
            dispatch(actions.change(`forms.dailyPMForm.${instance.props.quesNum}`,
                instance.props.answer));
        });
        }
    }

    isFieldsEmpty = (values) => {
        for (let k in values) {
            if (values[k] === 'Y*' || values[k] === '') {
                toast.error('You have marked Needs Work tab but did not add any appropriate comment.', {
                    position: toast.POSITION.TOP_CENTER,
                    className: 'failed-toast'
                });
                return true;
            }
        }
        return false;
    }
    handleFormSubmit = (values) => {
        
        if (this.isFieldsEmpty(values)) {
            return ;
        }
        
        const answer = marshallAnswersPlantPreventive(values);
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'PlantPreventive',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            ImageUrls: [], 
            DeletedImages : this.props.form.dailyPMForm.deletedImages || [],
            followUp_form: 0,
            SignatureUrls: [],
            AssociatedTo: null
        };
        QuestionModel.deleteAll();
        dispatch(actions.reset('forms.dailyPMForm'));
        return submitDailyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    renderContent = () => { 
        const Buttons = [ { 
            label : 'Needs Work',
            value : 'Y*'
        }, 
        {
            label: 'Ok',
            value: 'N*'
        }
    ];
        return <PerfectScrollbar>
        <Form
            loadDefaultValues={this.loadDefaultValues}
            model="forms.dailyPMForm"
            onSubmit={this.handleFormSubmit}
            className="form form-plantPreventive"
        >    
            <div className="outer-wrapper">
            <div>
            {this.state.MonthlyPPM1 && this.state.MonthlyPPM1.map((quesData, index) => (
                <RenderQuestion
               
                formType="PlantPreventive"
                formId={this.props.formId}
                key={index}
                uniqueValue={index}
                quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
                question={quesData.Question}
                questionType={quesData.Questiontype}
                model="dailyPMForm"
                buttons={Buttons}
                isCheck={true}
                customLabel={quesData.customLabel && quesData.customLabel}
                CommentQuestionLabel={quesData.CommentQuestionLabel ? quesData.CommentQuestionLabel : ''}
                containsComment={quesData.containsComment ? true : false}
                CommentQuestion={quesData.CommentQuestion ? quesData.CommentQuestion : ''}
                CommentQuestionNum={quesData.CommentQuestionNum ? quesData.CommentQuestionNum : null}
            />
            ))
            }
            </div>
            <span style={{ borderRight: '2px solid #2d2d2d' }}></span>
            <div>
            {this.state.MonthlyPPM2 && this.state.MonthlyPPM2.map((quesData, index) => (
                <RenderQuestion
                formType="PlantPreventive"
                formId={this.props.formId}
                key={index}
                uniqueValue={index}
                quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
                question={quesData.Question}
                questionType={quesData.Questiontype}
                model="dailyPMForm"
                buttons={Buttons}
                isCheck={true}
                customLabel={quesData.customLabel && quesData.customLabel}
                CommentQuestionLabel={quesData.CommentQuestionLabel ? quesData.CommentQuestionLabel : ''}
                containsComment={quesData.containsComment ? true : false}
                CommentQuestion={quesData.CommentQuestion ? quesData.CommentQuestion : ''}
                CommentQuestionNum={quesData.CommentQuestionNum ? quesData.CommentQuestionNum : null}
            />
            ))
            }
            </div>
            </div>
            <RenderQuestion 
                formId={this.props.formId}
                key="60"
                uniqueValue={54}
                quesNo="54"
                question="Notes:"
                questionType="Comments"
                CommentQuestionNum={54}
                model="dailyPMForm"
            />
            <ImageUpload
                ref="images"
                multi={true}
                label="Select Images to Upload:"
                defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
            />
            <FormFooter />
        </Form>
        </PerfectScrollbar>;
    }
    render() { 
        let title = `${getPageTitle(this.props.type, 'daily', this.props.date, 'inspection')} `;
        return (
            < BasePage pageTitle={ title /* `Plant Preventative Maintenance Inspections for ${this.props.date}` */} >
            <Async
                identifier="dailyForm"
                promise={this.promise}
                content={this.renderContent()}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
            />
        </BasePage>
        );
    }
}
export function mapStateToProps(state, ownProps) {
    const type = 'PlantPreventive';
    const date = ownProps.match.params.date;
    const questions = QuestionModel.getAllByType(type);  
    const formInstance = DailyFormsModel.get(ownProps.match.params.formId);  
    return {
        plantId: ownProps.match.params.plantId,
        questions, type, date,
        userUID: state.login.get('UniqueId'),
        formId: ownProps.match.params.formId, 
        form: state.forms, formInstance
    };
}
export const DailyPMForm = withRouter(connect<{}, {}, IDailyPMFormProps>(mapStateToProps)(DailyPMFormImpl));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/DailyForm/PlantPreventive.tsx